import React from 'react';
import PropTypes from 'prop-types';
import LandingPageTemplate from '../../components/04_templates/PageLayouts/LandingPage';
import Paragraphs from '../../components/02_molecules/Paragraphs';
import * as field from '../../utils/transforms.fields';
import '../../styles/styles.scss';

const NewsPage = ({ entity = null, blocks = [], breadcrumbs = [], layout = 'centered' }) => {
  const pageBlocks = blocks.map((block) => {
    if (!block) {
      return null;
    }

    const pageBlock = block;

    if (block.blockType === 'news_meta_info') {
      pageBlock.centeredLayoutMode = true;
    }

    return pageBlock;
  });

  pageBlocks.unshift(
    {
      blockType: 'breadcrumbs',
      breadcrumbs: {
        links:
          breadcrumbs && breadcrumbs.length > 1
            ? breadcrumbs
            : breadcrumbs.concat([
                {
                  label: 'News',
                  nextLink: {
                    as: '/news',
                    href: '/node/page',
                    isExternal: false,
                    route: '/node/page',
                    url: '/news',
                  },
                },
              ]),
        showOnMobile: false,
      },
    },
    {
      blockType: 'text_heading',
      title: field.getTextValue(entity, 'title'),
      Tag: 'h1',
    },
  );

  // Add Social Media share side bar
  pageBlocks.push({
    blockType: 'social_media_share',
    activeProviders: ['facebook', 'twitter', 'linkedin', 'link'],
    hasMobileBorders: true,
    isDesktopSticky: true,
  });

  return (
    <LandingPageTemplate>
      <Paragraphs blocks={pageBlocks} layout={layout} />
    </LandingPageTemplate>
  );
};

// Opt-out of Automatic Static Optimization.
// See https://nextjs.org/docs/api-reference/next.config.js/runtime-configuration
NewsPage.getInitialProps = async () => ({});

NewsPage.propTypes = {
  entity: PropTypes.shape({
    // TODO: Define entity object shape.
  }),
  blocks: PropTypes.arrayOf(
    PropTypes.shape({
      blockType: PropTypes.string.isRequired,
    }),
  ),
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      nextLink: PropTypes.shape({
        href: PropTypes.string,
        as: PropTypes.string,
      }),
    }),
  ),
  layout: PropTypes.string,
};

export default NewsPage;
